/**
 * @generated SignedSource<<b3990bdf4b6f82d9a12fa106e84a0b51>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type UpdateUserViewedWelcomeInput = {
  viewedWelcome: boolean;
};
export type UserViewedWelcomeMutation$variables = {
  input: UpdateUserViewedWelcomeInput;
};
export type UserViewedWelcomeMutation$data = {
  readonly updateUserViewedWelcome: {
    readonly user: {
      readonly id: number;
      readonly viewed_welcome: boolean;
    } | null | undefined;
  };
};
export type UserViewedWelcomeMutation = {
  response: UserViewedWelcomeMutation$data;
  variables: UserViewedWelcomeMutation$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "alias": null,
    "args": [
      {
        "kind": "Variable",
        "name": "input",
        "variableName": "input"
      }
    ],
    "concreteType": "UpdateUserViewedWelcomePayload",
    "kind": "LinkedField",
    "name": "updateUserViewedWelcome",
    "plural": false,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "users",
        "kind": "LinkedField",
        "name": "user",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "id",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewed_welcome",
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "UserViewedWelcomeMutation",
    "selections": (v1/*: any*/),
    "type": "mutation_root",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "UserViewedWelcomeMutation",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "726b9f26397a48625f9a77f8ef6eca8f",
    "id": null,
    "metadata": {},
    "name": "UserViewedWelcomeMutation",
    "operationKind": "mutation",
    "text": "mutation UserViewedWelcomeMutation(\n  $input: UpdateUserViewedWelcomeInput!\n) {\n  updateUserViewedWelcome(input: $input) {\n    user {\n      id\n      viewed_welcome\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "ebd6dfd04c999a744fa8f902d446d5ee";

export default node;
